import { Component, Input, OnInit } from '@angular/core';
import { DataService } from '../network/data.service';
import { HelpLinkService } from './help-link.service';

@Component({
  templateUrl: './help-link.component.html',
  styleUrls: ['./help-link.component.scss'],
  selector: 'help-link'
})
export class HelpLinkComponent implements OnInit {
    private _helpId: number;
    @Input() set helpId(value: number) {
        this._helpId = value;
    }
    private baseUrl: string;
    public url: string;
    
    @Input() overrideColor: string | undefined;

    constructor(private dataService: DataService, private helpLinkService: HelpLinkService) {
        this.baseUrl = dataService.getBaseUrl() + '/help/open/';
    }
    
    ngOnInit(): void {
        this.setArticleUrl();
        this.helpLinkService.registerLink(this._helpId);
    }

    private setArticleUrl() {
        this.url = `${this.baseUrl}${this._helpId}`;
    }
}